import { useMemo } from 'react';
import { usePermissions } from '../usePermissions';
import { useCanClientOnboardSubentities } from '../useCanClientOnboardSubentities';
export const useHasMarketplaceAccess = () => {
    const { hasPermission } = usePermissions();
    const canOnboard = useCanClientOnboardSubentities();
    const canReadMarketplace = useMemo(() => hasPermission('marketplace:read'), [hasPermission]);
    return canReadMarketplace && canOnboard;
};
